import { Container } from "./styles";
import BlocoStatus from "./BlocoStatus";
import { IProposta } from "../../../../utility/IProposta";
import BlocoInfoBasica from "./BlocoInfoBasica";
import BlocoDetalhesProcesso from "./BlocoDetalhesProcesso";
import BlocoEndereco from "./BlocoEndereco";

interface InfoLateralProps {
    demanda?: IProposta | null;
    loading: boolean;
    isEditing?: boolean;
    isSaving?: boolean;
    onChange?: (campo: string, valor: any) => void;
    onBlur?: (campo: string) => void;
    errors?: Record<string, string>;
    camposEditaveisRestritos?: boolean;
}

export default function InfoLateral({demanda, loading, isEditing, isSaving = false, onChange, onBlur, errors, camposEditaveisRestritos = false}: InfoLateralProps) {
    const isDisabled = isSaving || (isEditing && loading);
    
    const isEditingInfoBasica = camposEditaveisRestritos ? false : isEditing;
    const isEditingDetalhesProcesso = camposEditaveisRestritos ? false : isEditing;
    const isEditingEndereco = camposEditaveisRestritos ? false : isEditing;
    
    return (
        <Container>
            <BlocoStatus status={demanda?.status} loading={loading} />
            <BlocoInfoBasica demanda={demanda} loading={loading} isEditing={isEditingInfoBasica} isDisabled={isDisabled} onChange={onChange} onBlur={onBlur} errors={errors} />
            <BlocoDetalhesProcesso demanda={demanda} loading={loading} isEditing={isEditingDetalhesProcesso} isDisabled={isDisabled} onChange={onChange} onBlur={onBlur} errors={errors} />
            <BlocoEndereco demanda={demanda} loading={loading} isEditing={isEditingEndereco} isDisabled={isDisabled} onChange={onChange} onBlur={onBlur} errors={errors} />
        </Container>
    )
}